export default __webpack_public_path__ + "static/media/ep4collage4.9aa1891e.jpg";